import { AfterViewInit, Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { QuickLinkSignFormData } from '../../../../../../models/quick-link-sign-form-data';
import { AssetService } from '../../../../../../services/asset.service';
import { ApplicationStateService } from '../../../../../../services/application-state.service';
import { QuickLinkService } from '../../../../../../services/quick-link.service';
import { environment } from '../../../../../../../environments/environment';
import { TooltipUtils } from '../../../../../../utils/tooltip-utils';
import { RouteService } from '../../../../../../services/route.service';
import { AssignmentsLink } from '../../../../../../models/assignments-link';
import { DigiTrainerLink } from '../../../../../../models/digi-trainer-link';
import { ModalComponent } from '../../../../../../models/modal-component';
import { AssetPipe } from '../../../../../../pipes/asset.pipe';
import { AmComponent, Configuration } from '@lemberger/lemberger-am';
import { QuickLinkUtils } from '../../../../../../utils/quick-link-utils';

@Component({
    selector: 'app-assignments-link-modal',
    templateUrl: './assignments-link-modal.component.html',
    styleUrls: ['./assignments-link-modal.component.scss'],
    imports: [
        AssetPipe,
        AmComponent
    ],
    standalone: true
})
export class AssignmentsLinkModalComponent extends ModalComponent implements OnInit, AfterViewInit, OnDestroy {

    @Input() declare modalable: AssignmentsLink | DigiTrainerLink;

    iFrameURL: SafeResourceUrl;
    opendOnPage = false;
    iFrameId: string;

    isSignable: boolean;
    specialQuickLinkImageURL: string;
    formData: QuickLinkSignFormData;

    newHSMActive: boolean;

    loading: boolean;
    dirty: boolean;
    err: string;
    thiz = this;
    hsmConfig: Configuration;

    constructor(
        public sanitizer: DomSanitizer,
        public assetService: AssetService,
        public applicationStateService: ApplicationStateService,
        public quickLinkService: QuickLinkService,
        private routeService: RouteService) {
        super();
    }

    dirtFunc = $event => {
        this.dirty = true;
    };

    @HostListener('window:message', ['$event']) onPostMessage(event): void {
        // In some cases the h5p-resizer.js is overwriting our message ("hello" from the origin package - h5presizer.js)
        if ((typeof event.data === 'object' || (event.data instanceof Object)) && (event.data.action === 'hello')) {
            const iFrame = (document.getElementById(this.iFrameId) as HTMLIFrameElement)
                .contentWindow.document.getElementsByTagName('iframe')[0];
            const height = (iFrame as HTMLIFrameElement).contentWindow.document.body.offsetHeight;

            iFrame.style.width = '100%';
            iFrame.style.height = `${height + 25}px`;
        }

        // Resize outer iFrame
        if ((typeof event.data === 'object' || (event.data instanceof Object)) && (event.data.action === 'resize')) {
            const message: { context: string; originHeight: number; scrollHeight: number; action: string } = event.data;

            const iFrame = (document.getElementById(this.iFrameId) as HTMLIFrameElement)
                .contentWindow.document.getElementsByTagName('iframe')[0];
            iFrame.style.width = '100%';
            const newHeight = `${message.originHeight + 25}px`;

            iFrame.style.height = newHeight;
            window.top.postMessage({ iframe: this.iFrameId, height: newHeight }, '*');
        }
    }

    ngOnInit(): void {
        this.iFrameId = `bookviewerHSMiFrame_${Math.floor((Math.random() * 10000) + 1)}`;

        this.loading = true;
        this.newHSMActive = environment.features.newHsmActivated && this.applicationStateService.bookConfig.hsmActive;

        let quicklinks = [];
        let quicklink = undefined;
        if (this.modalable.link.includes(',')) {
            quicklinks = this.modalable.link.split(',').map(link => QuickLinkUtils.getLinkCode(link));
        } else {
            quicklink = QuickLinkUtils.getLinkCode(this.modalable.link);
        }

        this.hsmConfig = {
            quickLink: quicklink,
            quickLinks: quicklinks.length ? quicklinks : undefined,
            title: this.modalable.title,
            digiTrainer: this.modalable.digiTrainer ? '1' : undefined,
            user: this.applicationStateService.userData as any,
            bookConfig: this.applicationStateService.bookConfig as any,
            contextId: this.applicationStateService.bookId,
            embedded: true
        };

        this.initQuickLinkModal();

        window.document.addEventListener('contentChanged', this.dirtFunc, false);
    }

    ngAfterViewInit(): void {
        $(`#quickLink-${this.modalable.id}`)
            .on('shown.bs.modal', () => {
                const backdrop = $('.modal-backdrop');

                if (backdrop.length) {
                    backdrop.addClass('modal-backdrop-show');
                }
            });
    }

    ngOnDestroy(): void {
        $(`#quickLink-${this.modalable.id}`)
            .off('shown.bs.modal');

        window.document.removeEventListener('contentChanged', this.dirtFunc);
    }

    getModalId(): string {
        return 'assignmentsLinkModal';
    }

    getIFrameURL(): SafeResourceUrl {

        if (!this.iFrameURL) {
            let link;
            // eslint-disable-next-line max-len
            link = `${this.routeService.getAbsoluteRoute(environment.endpointUrls.hsmFrame, { quicklink: '' })}?assignments=${this.modalable.link}&title=${this.modalable.title}`;
            if (this.modalable.digiTrainer) {
                link += '&digiTrainer=1';
            }
            this.iFrameURL = this.sanitizer.bypassSecurityTrustResourceUrl(link);

            return this.iFrameURL;
        }

        return this.iFrameURL;
    }

    close(): void {
        $('html')
            .css('cursor', 'initial');
    }

    getId(): string {
        return this.modalable.getModalId();
    }

    /**
     * Performs some QuickLink init routine.
     */
    private initQuickLinkModal(): void {
        this.loading = false;
        ($('[data-bs-toggle="tooltip"]') as any).tooltip(TooltipUtils.defaultTooltipConfig);
        this.getIFrameURL();
    }
}
